export default "__VITE_ASSET__c6d93561__"